class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    const closeButton = this.querySelector('button[type="button"]')

    if(closeButton) {
      closeButton.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    const detailsElement = event.target.closest('details');
    detailsElement.setAttribute('open', true);
    
    // Ensure proper ARIA attributes
    if (!detailsElement.hasAttribute('aria-label') && !detailsElement.hasAttribute('aria-labelledby')) {
      const summaryText = this.summaryToggle.textContent.trim();
      if (summaryText) {
        detailsElement.setAttribute('aria-label', summaryText);
      }
    }
    
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusElement = this.detailsContainer.querySelector('input:not([type="hidden"])') ||
                        this.detailsContainer.querySelector('button:not([type="submit"])') ||
                        this.detailsContainer.querySelector('[tabindex="-1"]');
    
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer,
      focusElement
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
